module.exports = __webpack_public_path__ + "img/summer.be5030ca.webp";